<script>
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faPrint } from '@fortawesome/pro-light-svg-icons';

  // Props
  export let title = 'Print report';
  export let buttonClass = 'pagination mx-1 p-0 hide-on-print';
  export let delay = 500;

  // Enhanced print function with timing control for chart-heavy pages
  async function handlePrint() {
    try {
      // Step 1: Notify user that print is being prepared
      const printButton = document.querySelector(`[title="${title}"]`);
      if (printButton) {
        printButton.disabled = true;
        printButton.setAttribute('title', 'Preparing print...');
      }

      // Step 2: Trigger custom print preparation event for charts
      document.dispatchEvent(new CustomEvent('print-preparation'));
      
      // Step 3: Add print preparation class to trigger any print-specific styling
      document.body.classList.add('print-preparation');
      
      // Step 4: Wait for DOM updates and chart re-rendering
      await new Promise(resolve => {
        // Use requestAnimationFrame to ensure DOM changes are applied
        requestAnimationFrame(() => {
          setTimeout(resolve, delay);
        });
      });

      // Step 5: Remove preparation class and trigger print
      document.body.classList.remove('print-preparation');
      
      // Step 6: Trigger print dialog
      window.print();
      
    } catch (error) {
      console.error('Print preparation error:', error);
      // Fallback to direct print
      window.print();
    } finally {
      // Step 7: Re-enable print button
      const printButton = document.querySelector('[title="Preparing print..."]');
      if (printButton) {
        printButton.disabled = false;
        printButton.setAttribute('title', title);
      }
    }
  }
</script>

<button on:click={handlePrint} class={buttonClass} {title}>
  <FontAwesomeIcon icon={faPrint} />
</button>

<style>
  /* Print preparation styling */
  :global(.print-preparation) {
    cursor: wait;
  }

  :global(.print-preparation button[title="Preparing print..."]) {
    opacity: 0.5;
    cursor: wait;
  }

  /* Hide print button during actual print */
  @media print {
    :global(.hide-on-print) {
      display: none !important;
    }
  }
</style>
